"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavLink = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
/*
 * This component serves as a migration step to React Router v6 which no longer
 * supports activeClassName / activeStyle
 * */
const NavLink = react_1.default.forwardRef((_a, ref) => {
    var { activeClassName, activeStyle } = _a, props = __rest(_a, ["activeClassName", "activeStyle"]);
    return (react_1.default.createElement(react_router_dom_1.NavLink, Object.assign({ ref: ref }, props, { className: ({ isActive }) => [props.className, isActive ? activeClassName : null]
            .filter(Boolean)
            .join(' '), style: ({ isActive }) => (Object.assign(Object.assign({}, props.style), (isActive ? activeStyle : null))) })));
});
exports.NavLink = NavLink;
NavLink.displayName = 'NavLink';
